<template>
  <!-- PUBLIC / AUTH SCREENS (Login, Access, etc.) -->
  <div v-if="isMenu !== 1" class="min-h-screen relative">
    <!-- Vault background -->
    <div class="fixed inset-0 z-0 vault-gradient pointer-events-none"></div>

    <!-- Page content -->
    <div class="relative z-10">
      <router-view />
    </div>
  </div>

 <div v-else class="min-h-screen bg-neutral-bg font-display">
     <MainHeader/>
    <main class="max-w-[1440px] mx-auto px-12 py-12 space-y-12">
      <router-view />
    </main>
    <MainFooter/>
    <div v-if="isMenu === 1">
      <!-- Floating Button -->
      <button class="chat-fab" @click="chatOpen = !chatOpen">
        <i class='bx bx-headphone'></i>
      </button>

      <!-- Chat Popup -->
      <div v-if="chatOpen" class="chat-popup">
        <div class="chat-header">
          <div class="left">
           <i class='bx bx-headphone'></i>
            <div>
              <strong>Expert Support</strong>
              <p>We usually reply in minutes</p>
            </div>
          </div>

          <button class="close-btn" @click="chatOpen = false">
            <i class='bx bx-x'></i>
          </button>
        </div>

        <div class="chat-body">
          <div
            v-for="(m, i) in messages"
            :key="i"
            class="chat-msg"
            :class="m.role"
            v-html="beautifyMessage(m.message)"
          >
          </div>
        </div>

        <div class="chat-input">
          <input
            type="text"
            placeholder="Type your message…"
            v-model="msg_txt"
            @keyup.enter="sendMessage"
          />
          <button @click="sendMessage">
            <i class='bx bx-send'></i>
          </button>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import MainHeader from "@/comps/MainHeader.vue";
import MainFooter from "@/comps/MainFooter.vue";

import {
  getLastConvApi,
  sendMsgApi,
  getAiMsgApi
} from "@/apis/chatapis";

export default {
  components: { MainHeader, MainFooter },

  data() {
    return {
      chatOpen: false,

      ldata: null,
      isMenu: 0,

      conv: null,
      messages: [],

      msg_txt: "",

      user: {
        avatar: "https://i.pravatar.cc/100"
      },

      nav: ["Dashboard", "Intelligence", "Growth", "Vault"],

      plan: {
        name: "PRO",
        renewal: "Jan 12",
        coverage: "Standard Node Protection"
      },

      isSidebarOpen: false
    };
  },

 mounted() {
    this.updateMenu();

    const ldataRaw = sessionStorage.getItem("ldata");
    this.ldata = ldataRaw ? JSON.parse(ldataRaw) : null;

    if (this.ldata && this.ldata.user_id) {
      this.initChat();
    }
  },

  watch: {
    $route() {
      this.updateMenu();
    }
  },


  methods: {
    updateMenu() {

    const path = this.$route.path;

    if (
      path === "/login" ||
      path === "/signup" ||
      path === "/forgot-password" ||
      path.includes("/join")
    ) {
      this.isMenu = 0;
    } else {
      this.isMenu = 1;
    }

  },
    beautifyMessage(msg) {

      if (!msg) return "";

      msg = msg
        .replace(/\n/g, "<br>")
        .replace(/•/g, "&#8226;") // nicer bullets
        .trim();

      // Highlight numbers (VERY nice UX)
      msg = msg.replace(
        /(\d+(\.\d+)?%?)/g,
        "<strong>$1</strong>"
      );

      return msg;
    }

    ,
    // ==========================================================
    // INIT CHAT
    // ==========================================================
    async initChat() {

      const res = await getLastConvApi(this.ldata.user_id);

      if (res.status) {

        this.conv = res.conv_dt;

        // Initial bot greeting
        this.messages = [
          {
            role: "bot",
            message: "👋 Hi! How can our expert help you today?"
          }
        ];
      }
    },

    // ==========================================================
    // SEND MESSAGE
    // ==========================================================
    async sendMessage() {

      if (!this.msg_txt.trim()) return;
      if (!this.conv) return;

      const userMsg = this.msg_txt;

      // ✅ Push user message instantly (UI responsiveness)
      this.messages.push({
        role: "user",
        message: userMsg
      });

      this.msg_txt = "";

      const res = await sendMsgApi({
        user_id: this.ldata.user_id,
        msg_conv: this.conv.conv_id,
        msg_txt: userMsg
      });

      if (res.status && res.msg_dt) {

        // ✅ Fetch AI reply
        const ai = await getAiMsgApi(res.msg_dt.msg_id);

        if (ai.status) {

          // NOTE: backend already stored AI response
          // For MVP → optimistic UI append

          this.messages.push({
            role: "bot",
            message: "Typing..."
          });

          // Small delay for realism
          setTimeout(() => {

            this.messages.pop();

            this.messages.push({
              role: "bot",
              message: ai.msg.msg_txt || "AI response generated"
            });

            this.scrollChatToBottom();

          }, 600);
        }
      }

      this.scrollChatToBottom();
    },

    // ==========================================================
    // SCROLL FIX
    // ==========================================================
    scrollChatToBottom() {

      this.$nextTick(() => {
        const el = document.querySelector(".chat-body");
        if (el) el.scrollTop = el.scrollHeight;
      });
    }
  }
};

</script>

<style>
  .app-layout {
    overflow: hidden;
  }
  /* ===============================
   FLOATING CHAT BUTTON
   =============================== */

.chat-fab {
  position: fixed;
  right: 24px;
  bottom: 24px;
  width: 56px;
  height: 56px;
  border-radius: 50%;
  background: #0f172a;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 12px 30px rgba(0,0,0,0.25);
  z-index: 60;
}

.chat-fab span {
  font-size: 26px;
}

/* ===============================
   CHAT POPUP
   =============================== */

.chat-popup {
  position: fixed;
  right: 24px;
  bottom: 92px;
  width: 320px;
  max-height: 420px;
  background: white;
  border-radius: 20px;
  box-shadow: 0 20px 60px rgba(0,0,0,0.2);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  z-index: 60;
}

/* Header */
.chat-header {
  padding: 14px 16px;
  background: #0f172a;
  color: white;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.chat-header .left {
  display: flex;
  gap: 10px;
  align-items: center;
}

.chat-header p {
  font-size: 11px;
  opacity: 0.7;
}

.close-btn {
  background: none;
  border: none;
  color: white;
}

/* Body */
.chat-body {
  flex: 1;
  padding: 16px;
  background: #f8fafc;
  overflow-y: auto;
  min-height: 17rem;
}

.chat-msg {
  max-width: 80%;
  padding: 10px 12px;
  border-radius: 12px;
  font-size: 14px;
}

.chat-msg.bot {
  background: white;
  color: #0f172a;
}

/* Input */
.chat-input {
  display: flex;
  padding: 10px;
  border-top: 1px solid #e5e7eb;
  background: white;
}

.chat-input input {
  flex: 1;
  border: none;
  padding: 10px;
  font-size: 14px;
  background: #f8fafc;
  border-radius: 10px;
}

.chat-input button {
  margin-left: 8px;
  background: #0f172a;
  color: white;
  border-radius: 10px;
  padding: 0 12px;
}

/* ===============================
   MOBILE
   =============================== */

@media (max-width: 640px) {
  .chat-popup {
    right: 12px;
    left: 12px;
    width: auto;
  }

  .chat-fab {
    right: 16px;
    bottom: 16px;
  }
}
/* ===============================
   CHAT MESSAGE STYLING PATCH
   =============================== */

.chat-body {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

/* Base bubble */
.chat-msg {
  max-width: 78%;
  padding: 10px 14px;
  border-radius: 14px;
  font-size: 13.5px;
  line-height: 1.4;
  word-wrap: break-word;
  animation: fadeInChat 0.15s ease-out;
}

/* ✅ USER MESSAGE (Right / Black) */
.chat-msg.user {
  align-self: flex-end;
  background: #0f172a;
  color: white;
  border-bottom-right-radius: 6px;
}

/* ✅ AI / BOT MESSAGE (Left / White) */
.chat-msg.bot {
  align-self: flex-start;
  background: white;
  color: #0f172a;
  border-bottom-left-radius: 6px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.06);
}

/* Optional subtle entry animation */
@keyframes fadeInChat {
  from {
    opacity: 0;
    transform: translateY(2px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* ===============================
   MOBILE POLISH
   =============================== */

@media (max-width: 640px) {

  .chat-msg {
    max-width: 85%;
    font-size: 13px;
  }
}
.chat-msg.typing {
  background: white;
  color: #64748b;
  font-style: italic;
}

</style>